import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { DragDropContainer } from 'react-drag-drop-container';
import { Stage, Layer } from 'react-konva';

import { GenericComponentCanvas } from "./componentCanvas/GenericComponentCanvas";

class DraggableLayoutComponent extends React.Component {
    render() {
        const { dimentionsRatio, component } = this.props;

        return (
            <div className="drag-drop-container" id={`drag-${component.type.toLowerCase()}`}>
                <DragDropContainer targetKey="layoutBuilder"
                    dragClone={true}
                    dragData={component}
                    onDrag={this.props.onDrag}>
                    <Stage width={151} height={41} style={{ cursor: "pointer" }}>
                        <Layer>
                            <GenericComponentCanvas
                                component={component}
                                dimentionsRatio={dimentionsRatio}
                                draggable={false} />
                        </Layer>
                    </Stage>
                </DragDropContainer>
            </div>
        );
    }
}

export class AvailableComponentsCanvas extends Component {
    onDragMethod(dragData, currentTarget, positionAxisX, positionAxisY) {
        const { layout } = this.props;

        if (layout.isOver) {
            dragData.positionAxisX = positionAxisX - currentTarget.getBoundingClientRect().x;
            dragData.positionAxisY = positionAxisY - currentTarget.getBoundingClientRect().y;
        }
    }

    render() {
        const { componentsStyle } = this.props;

        const availableComponents = [
            // Notes
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 900, defaultHeight: 300, dimentionsRatio: 1, text: componentsStyle.notes.text, type: componentsStyle.notes.type, dataIdentifier: null, color: componentsStyle.notes.color },

            // SimpleText
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 900, defaultHeight: 300, dimentionsRatio: 1, text: componentsStyle.simpleText.text, type: componentsStyle.simpleText.type, dataIdentifier: null, color: componentsStyle.simpleText.color },

            // Image
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 500, defaultHeight: 500, dimentionsRatio: 1, text: componentsStyle.image.text, type: componentsStyle.image.type, dataIdentifier: null, color: componentsStyle.image.color },

            // QrCode
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 500, defaultHeight: 500, dimentionsRatio: 1, text: componentsStyle.qrCode.text, type: componentsStyle.qrCode.type, dataIdentifier: null, color: componentsStyle.qrCode.color },

            // DayTimesheet
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 400, dimentionsRatio: 1, text: componentsStyle.dayTimesheet.text, type: componentsStyle.dayTimesheet.type, dataIdentifier: null, color: componentsStyle.dayTimesheet.color },

            // CompactDayTimesheet
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 400, dimentionsRatio: 1, text: componentsStyle.compactDayTimesheet.text, type: componentsStyle.compactDayTimesheet.type, dataIdentifier: null, color: componentsStyle.compactDayTimesheet.color },

            // VerticalDayTimesheet
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 300, defaultHeight: 900, dimentionsRatio: 1, text: componentsStyle.verticalDayTimesheet.text, type: componentsStyle.verticalDayTimesheet.type, dataIdentifier: null, color: componentsStyle.verticalDayTimesheet.color },

            // HorizontalTabularDayTimesheet
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 500, dimentionsRatio: 1, text: componentsStyle.horizontalTabularDayTimesheet.text, type: componentsStyle.horizontalTabularDayTimesheet.type, dataIdentifier: null, color: componentsStyle.horizontalTabularDayTimesheet.color },
            
            // VerticalTabularDayTimesheet
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 500, dimentionsRatio: 1, text: componentsStyle.verticalTabularDayTimesheet.text, type: componentsStyle.verticalTabularDayTimesheet.type, dataIdentifier: null, color: componentsStyle.verticalTabularDayTimesheet.color },

            // Exceptions
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 500, dimentionsRatio: 1, text: componentsStyle.exceptions.text, type: componentsStyle.exceptions.type, dataIdentifier: null, color: componentsStyle.exceptions.color },

            // HorizontalStopsList
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 400, dimentionsRatio: 1, text: componentsStyle.horizontalStopsList.text, type: componentsStyle.horizontalStopsList.type, dataIdentifier: null, color: componentsStyle.horizontalStopsList.color },

            // VerticalStopsList
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 400, defaultHeight: 1200, dimentionsRatio: 1, text: componentsStyle.verticalStopsList.text, type: componentsStyle.verticalStopsList.type, dataIdentifier: null, color: componentsStyle.verticalStopsList.color },

            // SmsBus
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 200, defaultHeight: 200, dimentionsRatio: 1, text: componentsStyle.smsBus.text, type: componentsStyle.smsBus.type, dataIdentifier: null, color: componentsStyle.smsBus.color },

            // StopInformation
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 200, dimentionsRatio: 1, text: componentsStyle.stopInformation.text, type: componentsStyle.stopInformation.type, dataIdentifier: null, color: componentsStyle.stopInformation.color },

            // LineInformation
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 1200, defaultHeight: 200, dimentionsRatio: 1, text: componentsStyle.lineInformation.text, type: componentsStyle.lineInformation.type, dataIdentifier: null, color: componentsStyle.lineInformation.color },

            // Subtitle
            { id: 0, drawPositionX: 5, drawPositionY: 5, width: 145, height: 35, defaultWidth: 900, defaultHeight: 300, dimentionsRatio: 1, text: componentsStyle.subtitle.text, type: componentsStyle.subtitle.type, dataIdentifier: null, color: componentsStyle.subtitle.color }
        ];

        const availableComponentsElements = [];
        for (const idx in availableComponents) {
            availableComponentsElements.push(
                <DraggableLayoutComponent
                    key={idx}
                    component={availableComponents[idx]}
                    dimentionsRatio={1}
                    onDrag={(a, b, c, d) => this.onDragMethod(a, b, c, d)} />
            );
        }

        return (
            <Grid fluid>
                <Row>
                    <Col className="no-padding-left" sm={12}>
                        <div className="control-label">Configuração</div>
                        <small>(arraste os elementos para a folha de trabalho)</small>
                    </Col>
                </Row>
                <Row>
                    <Col className="no-padding-left" sm={12}>
                        {availableComponentsElements}
                    </Col>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/AvailableComponentCanvas.js